/* Copyright (c) 2020-present CloudIO Inc */

import { Item } from '../../registry/Component.type';
export const page: {
  root: Item<'Page'>;
  localDataStore: Item<'LocalDataStore'>;
  flexItem2: Item<'FlexItem'>;
  sparkLine: Item<'SparkLine'>;
  flexItem1: Item<'FlexItem'>;
  flexItem: Item<'FlexItem'>;
  flexPanel: Item<'FlexPanel'>;
  emptySpacer: Item<'EmptySpacer'>;
  emptySpacer1: Item<'EmptySpacer'>;
} = {
  emptySpacer: {
    children: [],
    itemId: 'emptySpacer',
    parent: 'flexItem2',
    props: {},
    type: 'EmptySpacer',
  },
  emptySpacer1: {
    children: [],
    itemId: 'emptySpacer1',
    parent: 'flexItem',
    props: {},
    type: 'EmptySpacer',
  },
  flexItem: {
    children: ['emptySpacer1'],
    itemId: 'flexItem',
    parent: 'flexPanel',
    props: {},
    type: 'FlexItem',
  },
  flexItem1: {
    children: ['sparkLine'],
    itemId: 'flexItem1',
    parent: 'flexPanel',
    props: {
      backgroundColor: 'paper',
      max: 500,
      min: 500,
      padding: {
        all: 16,
      },
      sizeType: 'minmax',
    },
    type: 'FlexItem',
  },
  flexItem2: {
    children: ['emptySpacer'],
    itemId: 'flexItem2',
    parent: 'flexPanel',
    props: {},
    type: 'FlexItem',
  },
  flexPanel: {
    children: ['flexItem2', 'flexItem1', 'flexItem'],
    itemId: 'flexPanel',
    parent: 'root',
    props: {
      renderAs: 'columns',
    },
    type: 'FlexPanel',
  },
  sparkLine: {
    children: [],
    itemId: 'sparkLine',
    parent: 'flexItem1',
    props: {
      dsalias: 'test',
      valueAttribute: 'value',
      caption: {
        type: 'text',
        value: 'Stock Price',
      },
      subCaption: {
        type: 'text',
        value: 'Last 30 Days',
      },
      lineColor: {
        type: 'text',
        value: '#6baa01',
      },
      lineThickness: 2,
      showOpenAnchor: true,
      showCloseAnchor: true,
      showHighAnchor: true,
      showLowAnchor: true,
      showTooltip: true,
    },
    type: 'SparkLine',
  },
  localDataStore: {
    children: [],
    itemId: 'localDataStore',
    parent: 'root',
    props: {
      alias: 'test',
      dataFormat: 'json',
      dataSource: 'test',
      jsonData: JSON.stringify([
        { value: 38.42 },
        { value: 41.43 },
        { value: 34.78 },
        { value: 40.67 },
        { value: 44.12 },
        { value: 38.45 },
        { value: 40.71 },
        { value: 49.9 },
        { value: 40.12 },
      ]),
    },
    type: 'LocalDataStore',
  },
  root: {
    children: ['localDataStore', 'flexPanel'],
    itemId: 'root',
    parent: 'root',
    props: {
      windowTitle: {
        type: 'text',
        value: 'CloudIO Help',
      },
    },
    type: 'Page',
  },
};
